import React from 'react';
import { Link } from 'react-router-dom';
import { COMPILED_LABEL } from '../../data/sources';
import { navItems } from '../../data/navigation';
export function SiteFooter() {
  return <footer className="relative mt-20 border-t border-line bg-surface" data-id="element-231" data-mp="t01ca55q1vah">
      <div className="mx-auto grid max-w-[1400px] gap-8 px-5 py-10 md:grid-cols-[1.4fr_1fr] md:px-8" data-id="element-232" data-mp="sxx0l11kzrzn">
        <div data-id="element-233" data-mp="xwi0ezcx89nk">
          <p className="font-serif text-lg text-ink" data-id="element-234" data-mp="1looufrv6c4jt">Agent Census</p>
          <p className="mt-2 max-w-md text-sm leading-relaxed text-muted" data-id="element-235" data-mp="1lmcdni15k08c">
            Data as of {COMPILED_LABEL} — every figure sourced. Ranges are explicit assumptions, clearly labeled.
          </p>
        </div>
        <nav aria-label="Footer" data-id="element-236" data-mp="1cq3hqdcdvjqy">
          <ul className="grid grid-cols-2 gap-x-6 gap-y-2 text-sm sm:grid-cols-4 md:grid-cols-2" data-id="element-237" data-mp="1gokmiq8c0i57">
            {navItems.map(item => <li key={item.to} data-id="element-238" data-mp="17agtwvv4ama">
                <Link to={item.to} className="text-muted transition-colors duration-150 hover:text-ink" data-id="element-239" data-mp="59xc67rqsdo8">
                  {item.label}
                </Link>
              </li>)}
          </ul>
        </nav>
      </div>
      <Link to="/frontier-7sigma" aria-label="." className="absolute bottom-2 right-3 px-1 font-mono text-xs text-faint/60 hover:text-faint focus-visible:text-ink" data-id="element-240" data-mp="1sxfh64fjq9no">
        .
      </Link>
    </footer>;
}